/** The main panel before any Result: the strapline and the four steps, over the backdrop. */

import { useBranding } from "@/lib/useBranding";

const CARDS = [
  { n: 1, title: "Audience", body: "Choose who reacts: the general public, or an audience built for your scenario." },
  { n: 2, title: "Message", body: "Paste the message exactly as people would see it." },
  { n: 3, title: "Promises", body: "List what every version must keep true, so suggested edits never drop it." },
  { n: 4, title: "Ask", body: "A community of personas reads it, talks it over, and you see how opinion moves." },
];

export function Hero() {
  const { brand } = useBranding();
  return (
    <section className="mx-auto flex min-h-full max-w-4xl flex-col justify-center gap-10 px-6 py-16">
      <h1 className="text-center text-3xl font-semibold text-white md:text-4xl">{brand.tagline}</h1>
      <ol className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {CARDS.map((card) => (
          <li key={card.n} className="rounded-xl border border-white/12 bg-black/55 p-4 backdrop-blur-sm">
            <span className="mb-2 inline-flex size-7 items-center justify-center rounded-full bg-white/10 text-sm font-bold">
              {card.n}
            </span>
            <h2 className="font-semibold text-white">{card.title}</h2>
            <p className="mt-1 text-sm text-slate-300">{card.body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
